// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2zu2L","title":"BackImages_title__2vKtJ","images":"BackImages_images__B6GrB"};